export default __webpack_public_path__ + "static/media/fitness-class-1.6c392b91.png";